import Environment from './environment';
import schema from './schema';

export default new Environment({ ...process.env, ...window.gymflow_env_config }, schema);
